module.exports = __webpack_public_path__ + "static/media/title2.0413f468.png";